module.exports = __webpack_public_path__ + "static/media/map.9b4ed12a.png";